export default __webpack_public_path__ + "static/media/resane.9d1b9c81.png";